import { jsx as t } from "react/jsx-runtime";
import { getInitials as d } from "./index.es5717.js";
import * as s from "@radix-ui/react-avatar";
import r from "./index.es5718.js";
import p from "classnames";
import { Heading as f } from "./index.es489.js";
const g = "avatar-component", u = ({
  name: e,
  src: o,
  size: m = "medium",
  testId: a = g,
  headingElement: n
}) => {
  var l;
  const c = p(r.avatarRoot, r[m]), i = e ? (l = d(e)) == null ? void 0 : l.toUpperCase() : null;
  return /* @__PURE__ */ t(s.Root, { className: c, "data-testid": a, children: /* @__PURE__ */ t(
    s.Fallback,
    {
      className: r.avatarFallback,
      "data-testid": a + "-fallback",
      children: i ? /* @__PURE__ */ t(
        f,
        {
          variant: m === "extra-large" ? "h1" : "h4",
          "data-testid": a + "-text",
          element: n,
          children: i
        }
      ) : o ? /* @__PURE__ */ t(
        "img",
        {
          className: r.image,
          src: o,
          alt: "avatar-image",
          "data-testid": a + "-image"
        }
      ) : null
    }
  ) });
};
export {
  g as AVATAR_DEFAULT_TESTID,
  u as Avatar
};
//# sourceMappingURL=index.es5477.js.map
